export const getCartTemplateCreateErrorText = (
  errorType: 'maxLength' | 'required' | 'taken' | undefined
): string | undefined => {
  let errorText: string | undefined = undefined

  if (errorType === 'required') {
    errorText = 'TEMPLATES.TEMPLATE_NAME_ERROR_REQUIRED'
  } else if (errorType === 'maxLength') {
    errorText = 'TEMPLATES.TEMPLATE_NAME_ERROR_MAX_LENGTH'
  } else if (errorType === 'taken') {
    errorText = 'TEMPLATES.TEMPLATE_NAME_ERROR_TAKEN'
  }

  return errorText
}
